import usePermission from "CustomHooks/usePermission";
import { action_options, app_modules } from "helpers/apps_modules_list";
import React, { useEffect, useState } from "react";

const Navdata = () => {
  // Get all permissions
  let { allPermissions } = usePermission();
  const user_permissions = allPermissions || [];

  // console.log("user_permissions:", user_permissions);

  // ================================================================
  const isAllUserManagementHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.user_management?.app_name
  );
  const isAllMasterHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.master?.app_name
  );

  const isAllWarehouseHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.warehouse?.app_name
  );
  const isAllInventoryHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.inventory?.app_name
  );

  const isAllOrderHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.order?.app_name
  );

  // below function is used to hide sidebase headers of collapsible
  function areAllPermissionsFalse(appObject: any) {
    // If no permission object exists, consider all permissions as false
    if (!appObject || !appObject.modules_permissions) {
      return true;
    }
    return appObject?.modules_permissions?.every(
      (module: any) =>
        !module.permissions.View &&
        !module.permissions.Create &&
        !module.permissions.Update
    );
  }

  // State data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isUserManagement, setIsUserManagement] = useState(false);
  const [isMasters, setIsMasters] = useState(false);
  const [isWarehouse, setIsWarehouse] = useState(false);
  const [isInventory, setIsInventory] = useState(false);
  const [isOrder, setIsOrder] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id: any = item.getAttribute("sub-items");
        var menusId = document.getElementById(id);
        if (menusId) {
          (menusId.parentElement as HTMLElement).classList.remove("show");
        }
      });
      e.target.classList.add("active");
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") setIsDashboard(false);
    if (iscurrentState !== "UserManagement") setIsUserManagement(false);
    if (iscurrentState !== "Masters") setIsMasters(false);
    if (iscurrentState !== "Warehouse") setIsWarehouse(false);
    if (iscurrentState !== "Inventory") setIsInventory(false);
    if (iscurrentState !== "Order") setIsOrder(false);
  }, [
    iscurrentState,
    isUserManagement,
    isDashboard,
    isMasters,
    isInventory,
    isOrder,
  ]);

  const menuItems: any = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ph-gauge",
      link: "/dashboard",
      activeUrl: ["/dashboard"],
      permissions: {
        app_name: app_modules.dashboard.app_name,
        module_name: app_modules.dashboard.modules.dashboard,
        action: action_options?.view,
      },
    },

    !areAllPermissionsFalse(isAllUserManagementHavePermission) && {
      label: "User Management",
      isHeader: true,
    },
    {
      id: "userManagement",
      label: "User Management",
      icon: "ph-user",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUserManagement(!isUserManagement);
        setIscurrentState("UserManagement");
        updateIconSidebar(e);
      },
      stateVariables: isUserManagement,
      subItems: [
        // {
        //   id: "organisations",
        //   label: "Organisation",
        //   icon: "ph-buildings",
        //   link: "/organisations-list",
        //   activeUrl: ["/organisation-form", "/edit-organisation/:id"],
        //   parentId: "userManagement",
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules?.user_management.modules.organisation,
        //     action: action_options?.view,
        //   },
        // },
        // {
        //   id: "departments",
        //   label: "Department",
        //   icon: "ph-briefcase",
        //   link: "/departments-list",
        //   activeUrl: [
        //     "/departments-list",
        //     "/department-form",
        //     "/department-form/:id",
        //   ],
        //   parentId: "userManagement",
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules?.user_management.modules?.department,
        //     action: action_options?.view,
        //   },
        // },

        // {
        //   id: "teams",
        //   label: "Team",
        //   icon: "ph-users-three",
        //   link: "/team-list",
        //   activeUrl: ["/team-list", "/team-forms", "/team-forms/:id"],
        //   parentId: "userManagement",
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules?.user_management.modules?.team,
        //     action: action_options?.view,
        //   },
        // },
        {
          id: "users",
          label: "Users",
          icon: "ph-user-circle",
          link: "/user-list",
          activeUrl: ["/user-list", "/user-form", "/user-form/:id"],
          parentId: "userManagement",
          permissions: {
            app_name: app_modules.user_management.app_name,
            module_name: app_modules?.user_management.modules?.user,
            action: action_options?.view,
          },
        },
        // {
        //   id: "UserTypes",
        //   label: "User Types",
        //   icon: "ph-identification-card",
        //   link: "/user-type",
        //   parentId: "master",
        //   activeUrl: ["/user-type", "/add-usertypes", "/add-usertypes/:id"],
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules.user_management.modules.user_types,
        //     action: action_options?.view,
        //   },
        // },
        // {
        //   id: "Modules",
        //   label: "Module",
        //   icon: "ph-cube",
        //   link: "/module-list",
        //   activeUrl: ["/module-list", "/module-form", "/edit-module-form"],
        //   parentId: "userManagement",
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules?.user_management.modules?.module,
        //     action: action_options?.view,
        //   },
        // },
      ],
    },

    !areAllPermissionsFalse(isAllMasterHavePermission) && {
      label: "Masters",
      isHeader: true,
    },
    {
      id: "master",
      label: "Masters",
      icon: "ph-storefront",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsMasters(!isMasters);
        setIscurrentState("Masters");
        updateIconSidebar(e);
      },
      stateVariables: isMasters,
      subItems: [
        {
          id: 1,
          label: "Category",
          icon: "ph-folder",
          link: "/category",
          parentId: "master",
          activeUrl: ["/category", "/add-category", "/edit-category/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.category,
            action: action_options?.view,
          },
        },
        {
          id: 2,
          label: "Sub Category",
          icon: "ph-folder-simple",
          link: "/sub-category",
          parentId: "master",
          activeUrl: [
            "/sub-category",
            "/add-sub-category",
            "/edit-sub-category/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.subcategory,
            action: action_options?.view,
          },
        },

        {
          id: 3,
          label: "Unit",
          icon: "ph-ruler",
          link: "/unit",
          parentId: "master",
          activeUrl: ["/unit", "/add-unit", "/edit-unit/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.unit,
            action: action_options?.view,
          },
        },
        {
          id: 4,
          label: "GST",
          icon: "ph-receipt",
          link: "/gst",
          parentId: "master",
          activeUrl: ["/gst", "/add-gst", "/edit-gst/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.gst,
            action: action_options?.view,
          },
        },
        {
          id: 5,
          label: "HSN Code",
          icon: "ph-barcode",
          link: "/hsn-codes",
          parentId: "master",
          activeUrl: ["/hsn-codes", "/add-hsn-code", "/edit-hsn-code/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.hsn_code,
            action: action_options?.view,
          },
        },

        {
          id: 6,
          label: "Item",
          icon: "ph-package",
          link: "/item",
          parentId: "master",
          activeUrl: [
            "/item",
            "/add-item",
            "/edit-item/:id",
            "/item-details/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.item,
            action: action_options?.view,
          },
        },

        {
          id: 7,
          label: "Suppliers",
          icon: "ph-truck",
          link: "/supplier-list",
          parentId: "master",
          activeUrl: [
            "/supplier-list",
            "/add-supplier",
            "/edit-supplier/:id",
            "/supplier-view-details/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.suppliers,
            action: action_options?.view,
          },
        },

        {
          id: 8,
          label: "Warehouse",
          link: "/warehouse-list",
          icon: "ph-house",
          parentId: "master",
          activeUrl: [
            "/warehouse-list",
            "/add-warehouse",
            "/edit-warehouse/:id",
            "/configure-warehouse/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.warehouse,
            action: action_options?.view,
          },
        },
        {
          id: 9,
          label: "Labour",
          link: "/labour",
          icon: "ph-wrench",
          parentId: "master",
          activeUrl: ["/labour", "/add-labour", "/edit-labour/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.labour,
            action: action_options?.view,
          },
        },
        {
          id: 10,
          label: "Customer",
          link: "/customer",
          icon: "ph-users",
          parentId: "master",
          activeUrl: [
            "/customer",
            "/add-customer",
            "/edit-customer/:id",
            "/customer-details/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.customer,
            action: action_options?.view,
          },
        },
      ],
      permissions: {
        app_name: app_modules.master.app_name,
        module_name: app_modules.master.modules.master,
        action: action_options?.view,
      },
    },

    // Warehouse sidemenu
    !areAllPermissionsFalse(isAllWarehouseHavePermission) && {
      label: "Warehouse",
      isHeader: true,
    },
    {
      id: "warehouse",
      label: "Warehouse",
      icon: "ph-bag",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsWarehouse(!isWarehouse);
        setIscurrentState("Warehouse");
        updateIconSidebar(e);
      },
      stateVariables: isWarehouse,
      subItems: [
        {
          id: 1,
          label: "Warehouse Overview",
          icon: "ph-eye",
          link: "/warehouse-overview",
          parentId: "warehouse",
          activeUrl: [
            "/warehouse-overview",
            "/warehouse-overview/view-warehouse-in-stock/:id",
            "/warehouse-overview/view-warehouse-in-stock/:master_item_id/:warehouse_id",
          ],
          permissions: {
            app_name: app_modules?.warehouse.app_name,
            module_name: app_modules?.warehouse.modules?.warehouse_overview,
            action: action_options?.view,
          },
        },
        {
          id: 2,
          label: "Item Inward",
          icon: "ph-arrow-down",
          link: "/warehouse-item-inward",
          parentId: "warehouse",
          activeUrl: [
            "/warehouse-item-inward",

            // Supplier GRN
            "/warehouse-grn-details/:id",
            "/warehouse-item-inward-create-grn",
            "/warehouse-item-inward-create-grn/:id",

            // Stock Transfer
            "/warehouse-stock-transfer-item-inward-grn/:dispatch_id",
            "/warehouse-stock-transfer-item-inward-edit-grn/:id",

            // Labour Inward
            "/warehouse-labour-item-inward-grn/:id",
            "/warehouse-labour-item-inward-grn-edit/:id",

            // Sales Order Return
            "/warehouse-sales-inward-create-grn/:id",
            "/warehouse-sales-return-item-inward-grn/:dispatch_id",
            "/warehouse-sales-return-edit-item-inward-grn/:id",
          ],
          permissions: {
            app_name: app_modules?.warehouse.app_name,
            module_name: app_modules?.warehouse.modules?.item_inward,
            action: action_options?.view,
          },
        },

        {
          id: 3,
          label: "Dispatch",
          icon: "ph-truck",
          link: "/warehouse-dispatch",
          parentId: "warehouse",
          activeUrl: [
            "/warehouse-dispatch",

            // Ready For Dispatch
            "/warehouse-dispatch/ready-for-dispatch/create-dispatch/:order_id",
            "/warehouse-dispatch/ready-for-dispatch/edit-dispatch/:order_id/:dispatch_id",
            "/warehouse-dispatch/ready-for-dispatch/view-details/:id",

            // Dispatch
            "/warehouse-dispatch/dispatch/view-details/:dispatch_id",
            "/warehouse-dispatch/dispatch/sales-order-return/:dispatch_id",
            "/warehouse-dispatch/dispatch/edit-dispatch",

            // Stock Transfer Dispatch
            "/warehouse-dispatch/stockTransfer/create-stock-transfer",
            "/warehouse-dispatch/StockTransfer/view-details/:id",
            "/warehouse-dispatch/stockTransfer/edit-stockTransfer/:id",

            // Issue to Labour
            "/warehouse-dispatch/IssueToLabour/create-dispatch-labour",
            "/warehouse-dispatch/IssueToLabour/view-details/:id",
            "/warehouse-dispatch/IssueToLabour/edit-issueToLabour/:id",
          ],
          permissions: {
            app_name: app_modules?.warehouse.app_name,
            module_name: app_modules?.warehouse.modules?.dispatch,
            action: action_options?.view,
          },
        },
      ],
    },

    // // Inventory sidemenu
    !areAllPermissionsFalse(isAllInventoryHavePermission) && {
      label: "Inventory",
      isHeader: true,
    },
    {
      id: "inventory",
      label: "Inventory",
      icon: "ph-shopping-cart",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsInventory(!isInventory);
        setIscurrentState("Inventory");
        updateIconSidebar(e);
      },
      stateVariables: isInventory,
      subItems: [
        {
          id: 1,
          label: "In Stock",
          icon: "ph-stack",
          link: "/inventory-in-stock",
          parentId: "inventory",
          activeUrl: [
            "/inventory-in-stock",
            "/view-stockoverview-in-stock/:id",
            "/view-warehousewisestockdetails/:item_id/:warehouse_id",
          ],
          permissions: {
            app_name: app_modules?.inventory.app_name,
            module_name: app_modules?.inventory.modules?.in_stock,
            action: action_options?.view,
          },
        },
        {
          id: 6,
          label: "Dispatch",
          icon: "ph-truck",
          link: "/inventory-dispatch",
          parentId: "inventory",
          activeUrl: [
            "/inventory-dispatch",
            "/inventory-dispatch/StockTransfer/view-details/:id",
            "/inventory-dispatch/dispatch/view-details/:id",
            "/inventory-dispatch/issuelabour/view-details/:id",
          ],
          permissions: {
            app_name: app_modules?.inventory.app_name,
            module_name: app_modules?.inventory.modules?.dispatch,
            action: action_options?.view,
          },
        },
        {
          id: 8,
          label: "Order",
          icon: "ph-shopping-cart",
          link: "/inventory-order",
          parentId: "inventory",
          activeUrl: ["/inventory-order", "/view-inventoryorder/:id"],
          permissions: {
            app_name: app_modules?.inventory.app_name,
            module_name: app_modules?.inventory.modules?.order,
            action: action_options?.view,
          },
        },
        {
          id: 7,
          label: "Reorder Level",
          icon: "ph-warning",
          link: "/inventory-reorder-level",
          parentId: "inventory",
          activeUrl: [
            "/inventory-reorder-level",
            "/inventory-create-reorder-level",
          ],
          permissions: {
            app_name: app_modules?.inventory.app_name,
            module_name: app_modules?.inventory.modules?.reorder_level,
            action: action_options?.view,
          },
        },
      ],
    },

    !areAllPermissionsFalse(isAllOrderHavePermission) && {
      label: "Order",
      isHeader: true,
    },
    {
      id: "order",
      label: "Order",
      icon: "ph-package",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsOrder(!isOrder);
        setIscurrentState("Order");
        updateIconSidebar(e);
      },
      stateVariables: isOrder,
      subItems: [
        {
          id: "Enquiry",
          label: "Enquiry",
          icon: "ph-question",
          link: "/enquiry",
          parentId: "order",
          activeUrl: [
            "/enquiry",
            "/enquiry-form",
            "/enquiry-form/:id",
            "/enquiry-details/:id",
          ],
          permissions: {
            app_name: app_modules.order.app_name,
            module_name: app_modules.order.modules.enquiry,
            action: action_options?.view,
          },
        },

        {
          id: "Quotation",
          label: "Quotation",
          icon: "ph-pencil",
          link: "/quotation",
          activeUrl: [
            "/quotation/",
            "/quotation/create",
            "/quotation/create/:id",
            "/quotation/edit/:id",
            "/quotation/view/:id",
          ],
          permissions: {
            app_name: app_modules.order.app_name,
            module_name: app_modules.order.modules.quotation,
            action: action_options?.view,
          },
        },

        {
          id: "Site_Visit",
          label: "Site Visit",
          icon: "ph-buildings",
          link: "/sitevisit",
          activeUrl: [
            "/sitevisit",
            "/sitevisit-form/:id",
            "/sitevisit-details/:id",
          ],
          permissions: {
            app_name: app_modules.order.app_name,
            module_name: app_modules.order.modules.site_visit,
            action: action_options?.view,
          },
        },

        {
          id: "Order",
          label: "Order",
          icon: "ph-package",
          link: "/order-list",
          activeUrl: [
            "/order-list",
            "/add-order",
            "/add-quotation-order/:quotation_id",
            "/edit-order/:id",
            "/edit-quotation-order/:id/:quotation_id",
            "/view-order/:id",
            "/cancel-order/:id",
          ],
          permissions: {
            app_name: app_modules.order.app_name,
            module_name: app_modules.order.modules.order,
            action: action_options?.view,
          },
        },
      ],
    },
  ];

  const hasPermission = (
    app_name: string,
    module_name: string,
    permission: string
  ): boolean => {
    return user_permissions?.some(
      (app: any) =>
        app.apps_name === app_name &&
        app.modules_permissions?.some(
          (module: any) =>
            module.modules_name === module_name &&
            module.permissions?.[permission] === true
        )
    );
  };

  const filterItemsWithPermissions = (items: any[]): any[] => {
    return items
      .map((item: any) => {
        if (item.subItems?.length) {
          const filteredSubItems = filterItemsWithPermissions(item.subItems);

          if (filteredSubItems.length) {
            return { ...item, subItems: filteredSubItems };
          }
          return null;
        }
        if (item.permissions) {
          const { app_name, module_name, action } = item.permissions;
          return hasPermission(app_name, module_name, action) ? item : null;
        }
        return item;
      })
      .filter(Boolean);
  };

  const filteredMenuItems = filterItemsWithPermissions(menuItems);
  // const filteredMenuItems = menuItems;

  return (
    <React.Fragment>
      {filteredMenuItems}
      {/* {menuItems} */}
    </React.Fragment>
  );
};

export default Navdata;
